<template>
  <div class="w-full bg-slate-50">
    <div class="flex max-w-full mx-auto">
      <div class="z-10 flex-none">
        <SidebarComponent />
      </div>
      <div
        id="user-dashboard-layout"
        class="relative flex flex-col h-screen overflow-x-hidden overflow-y-scroll grow"
      >
        <div class="sticky top-0 z-20">
          <DashboardNavbarComponent />
        </div>
        <MaintenanceBanner />
        <main class="px-4 py-6 sm:px-6 lg:px-8 z-1">
          <slot />
        </main>
      </div>
    </div>
    <GlobalTranslationLoader />
  </div>
</template>
